
<div class="pdf-export-wrapper">

  <div class="pdf-export">
    <ng-template *ngTemplateOutlet="header"></ng-template>

    <ng-container>
      <ng-container *ngFor="let field of siteFormResponse.form.data; let i = index;">
        <ng-template *ngTemplateOutlet="dynamicFormField; context: {$implicit: field, i: i}"></ng-template>
      </ng-container>
    </ng-container>
  </div>

</div>


<ng-template #header>
  <div class="d-flex justify-content-between flex-row-reverse header-logo-row">
    <img *ngIf="logoUrl" [src]="logoUrl" class="header-logo" />
  </div>
</ng-template>

<ng-template #dynamicFormField let-field let-i="i">
  <!-- inputs -->
  <ng-container *ngIf="field.type === 'textField' || field.type === 'textArea' || field.type === 'dateField' || field.type === 'timeField' || field.type === 'radioButton' || field.type === 'checkboxList'">
    <dl class="d-flex flex-wrap gap-c">
      <dt>{{field.label}}</dt>
      <dd>{{siteFormResponse.getAnswer(i)}}</dd>
    </dl>
  </ng-container>

  <!-- attachments -->
  <ng-container *ngIf="field.type === 'imageUpload'">
    <dl class="d-flex flex-wrap gap-c">
      <dt>{{field.label}}</dt>
      <dd>{{siteFormResponse.getAnswer(i)}}</dd>
      <ng-container *ngIf="includePhotos">
        <div *ngIf="field.imageUrls" class="site-form-photo-grid">
          <div class="photoWrapper" *ngFor="let file of field.imageUrls">
            <img [src]="file" />
          </div>
        </div>
      </ng-container>
    </dl>
  </ng-container>

  <ng-container *ngIf="field.type === 'documentUpload'">
    <dl class="d-flex flex-wrap gap-c">
      <dt>{{field.label}}</dt>
      <dd *ngFor="let document of siteFormResponse.getAnswer(i).split(',')">{{document}}</dd>
    </dl>
    <p>See documents at:</p>
    <p>{{environment.sourceUrl}}/site-owner/site-forms/{{siteFormResponse.form.id}}/response/{{siteFormResponse.id}}</p>
  </ng-container>

  <!-- table -->
  <ng-container *ngIf="field.type === 'table'">
    <div class="table-wrapper">
      <table [id]="'my-table-' + i">
        <thead>
          <tr>
            <th [attr.colspan]="field.fields.length">{{field.label}}</th>
          </tr>
          <tr>
            <th *ngFor="let fieldInner of field.fields">{{fieldInner.label}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of siteFormResponse.answers[i]">
            <td *ngFor="let fieldInner of field.fields; let j = index">{{row[j]}}</td>
          </tr>
          <tr *ngIf="!siteFormResponse.answers[i] || !siteFormResponse.answers[i].length">
            <td [attr.colspan]="field.fields.length">
              No Answers
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <!-- structure -->
  <ng-container *ngIf="field.type === 'headerLarge'">
    <h2>{{field.text}}</h2>
  </ng-container>
  <ng-container *ngIf="field.type === 'headerSmall'">
    <h4>{{field.text}}</h4>
  </ng-container>

</ng-template>
